import { TFormValidationResult } from '../../models'

export class FormValidation {
  private handlers: Map<string, (value: any) => Promise<string>>
  constructor() {
    this.handlers = new Map()
  }
  public add<T>(params: { field: string; handler: (value: T) => Promise<string> }) {
    this.handlers.set(params.field, params.handler)
  }
  public async call<T>(field: string, value: T): Promise<TFormValidationResult | undefined> {
    const handler = this.handlers.get(field)
    if (handler) {
      const message = await handler(value)
      if (message) {
        return { field, message }
      }
    }
    return
  }

  public clear() {
    this.handlers = new Map()
  }
}
